module.exports = __webpack_public_path__ + "img/news5.a23d93d1.png";